import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectSetTable(state),
        type: 'set',
    }
}

const mapDispatchToProps = {

    initialTableQuery: action.initialTableQuerySet,
    changeFilter: action.changeFilterSet,
    toggleSort: action.toggleSortSet,
    toggleMultiSort: action.toggleMultiSortSet,
    gotoPage: action.gotoPageSet,
    initialColumnsVisibility: action.initialTableSettingsSet,
    toggleColumnVisibility: action.toggleColumnVisibilitySet,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/SetSalesOrderSearchContainer.js